import {capitalize} from 'common/util/string';
import {getReportName} from 'common/report/util';

import {SearchSortOption} from './types';

export const searchEventPrefix = `Content Discovery`;

export enum SearchTrackedEvent {
  ClosedModal = `Report List - Close`,
  EditSearchQuery = `Edit Search Query`,
  OpenModal = `Report List - Open`,
  RecentQuerySelected = `Recent Query Selected`,
  RecentResultDeleted = `Recent Result Deleted`,
  ResetSearchQuery = `Reset Search Query`,
  ResultSelected = `Result Selected`,
  SelectReport = `Report List - Selected`,
  SearchResultLoaded = `Search Result Loaded`,
  SearchErrored = `Search Errored`,
  Sort = `Sort Search Results`,
  UpdateFilter = `Update Filter`,
}

export enum SearchTrackedProperty {
  // represents the stage of content discovery, such as browse (opening and looking for content
  // getting recent results, and the result after searching for something)
  ContentDiscoveryType = `Content Discovery Type`,
  IsOwner = `is owner`,
  Owner = `Owner`,
  OwnerFilters = `Ownership Filters`, // me, not me, anyone
  PhaseVersion = `Phase Version`,
  PopularityScore = `Popularity Score`,
  FinalScore = `Final Score`,
  ReportDescription = `Result Description`,
  ReportFilters = `Report Type Filters`, // insights, funnels, etc
  ReportTitle = `Result Name`,
  ReportType = `Report name`, // type of the report, insights, funnels, etc
  ResultAmount = `Number of Results`,
  ResultsWithPopularity = `Results with popularity score`,
  ResultLink = `Result Link`,
  ResultPosition = `Result Position`,
  SearchAccessPoint = `Search Access Point`, // where the user came from: insights, funnels, dashboards, etc
  SearchQuery = `Search Query`,
  ShortcutDisplayName = `Shortcut Display Name`,
  Source = `Search Source of Query`, // dropdown or modal?
  SortValue = `Sort Option`, // recent, a-z, etc
}

export enum SearchPhaseVersion {
  Old = 0,
  PhaseOne = 1,
  PhaseTwo = 2,
  PhaseThree = 3,
}

export enum SearchSource {
  Dropdown = `Dropdown`,
  Modal = `Modal`,
  Library = `Library`,
}

export enum ContentDiscoveryType {
  // represents the stage of content discovery, such as browse (opening and looking for content
  // getting recent results, and the result after searching for something)
  Browse = `Browse`,
  RecentResults = `Recent Results`,
  SearchQuery = `Search Query`,
}

export function getSearchCommonTrackingProperties() {
  return {
    [SearchTrackedProperty.SortValue]: SearchSortOption.Default,
    [SearchTrackedProperty.PhaseVersion]: SearchPhaseVersion.PhaseThree,
    [SearchTrackedProperty.SearchAccessPoint]: capitalize(getReportName()),
  };
}
